import { render, staticRenderFns } from "./RelatorioCell.vue?vue&type=template&id=1446e418"
import script from "./RelatorioCell.vue?vue&type=script&lang=js"
export * from "./RelatorioCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports